import {
  Stack,
  Typography,
  Card,
  FormHelperText,
  TextFieldVariants,
} from '@mui/material'
import { ProjectGridField } from '@/types/fields'
import { FormTextField } from '@/components/forms'

type FieldAIInstructionsProps = {
  field?: ProjectGridField
  /** Leave out to use the theme's default text field variant. */
  variant?: TextFieldVariants
}

export default function FieldAIInstructions({
  field,
  variant,
}: FieldAIInstructionsProps) {
  const infoTypeDescription = field?.info_type?.long_description || ''

  const baseHelperText = `If an AI is used to set the value of this field, it will receive these instructions. 
                          Describe the intended purpose for this field. Include any instructions, details, or 
                          exceptions for how the value for this field should be found or calculated.`

  const formTextField = (
    <FormTextField
      name="description"
      label={
        infoTypeDescription ? 'Additional Instructions' : 'AI Instructions'
      }
      multiline
      variant={variant}
      helperText={infoTypeDescription ? undefined : baseHelperText}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
      }}
    />
  )

  if (!infoTypeDescription) {
    return formTextField
  }
  return (
    <Stack spacing={0.5}>
      <Card component={Stack} spacing={1} variant="outlined" sx={{ p: 1.5 }}>
        <Typography color="textSecondary">AI Instructions</Typography>

        <Stack spacing={1}>
          <Typography sx={{ mt: 1 }}>{infoTypeDescription}</Typography>
          {formTextField}
        </Stack>
      </Card>
      <FormHelperText sx={{ px: 1.5 }}>{baseHelperText}</FormHelperText>
    </Stack>
  )
}
